import { gql } from '@apollo/client';

export const GET_PRACTICE_TESTS = gql`
  query PracticeTests {
    practiceTests {
      id
      practiceTestStatus
      completedAt
      tester {
        id
        project {
          id
        }
        user {
          id
          email
          profile {
            id
            firstName
            lastName
            country
          }
        }
      }
    }
  }
`;

export const UPDATE_STATUS = gql`
  mutation UpdatePracticeTestStatus($id: ID!, $status: PracticeTestEnum!) {
    updatePracticeTestStatus(id: $id, status: $status) {
      testSession {
        id
        practiceTestStatus
        completedAt
        tester {
          id
          project {
            id
          }
          user {
            id
            email
            profile {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
